import styles from './TopApplicators.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import Loader from '../../../miscellaneous/Loader/Loader';
import { Link } from 'react-router-dom';

const TopApplicators = ({dateRange}) => {
    const { startDate, endDate } = dateRange;
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ type, setType ] = useState('Trio 2cm');

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            // console.log(res)
            setData(res)
        }).catch(e => {
            console.error(e)
        })
    }, [dateRange])

    useEffect(() => {
        if(data !== null) {
            setIsLoaded(true)
        }
    }, [data])

    const getData = async () => {
        const data = await api.get(`dashboard/applicators/top?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    const getShortName = (name) => {
        return name.split(' ')[0]
    }

    const getPrettyNumber = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    return (<div className='' style={{minHeight: 300}}>
        {isLoaded ? <>
            <div className={styles.typeMenu}>
                <span>Select: </span>
                {['Trio 2cm', 'Trio 4cm'].map((t, i) => {
                    return <label onClick={(e) => {
                        setType(t)
                    }} key={i} type="button" style={t === type ? {fontWeight: 800} : {color: '#908e94'}}>{t}</label>
                })}
            </div>
            <table className={styles.table}>
            <thead>
                <tr>
                    <th>Applicator</th>
                    <th>Clinic</th>
                    <th>Pulses</th>
                </tr>
            </thead>
            <tbody>
                { data.filter(item => item.handle_type === type).map((item, index) => {
                    return <tr className={styles.row} key={ index }>
                        <td>{ item.handle_type }</td>
                        <td><Link to={`/clinic/${item.clinic_id}`}>{ getShortName(item.clinic_name) }</Link></td>
                        <td>{ getPrettyNumber(item.pulses) }</td>
                    </tr>
                }) }
            </tbody>
        </table>
    </> : <div style={{margin: 'auto'}}><Loader color="#ddd"></Loader></div>}
    </div>)
}


export default TopApplicators;